"use client";
import { useEffect } from "react";
import { useRouter } from "next/navigation";
import { useAuth } from "@/lib/auth";

export default function RootPage() {
  const router = useRouter();
  const { token } = useAuth();
  useEffect(() => {
    if (token) router.replace("/workspace/dashboard");
    else router.replace("/login");
  }, [token, router]);
  return (
    <div className="flex h-screen items-center justify-center">
      <div className="text-sm text-slate-400">Loading…</div>
    </div>
  );
}